import { Component, Input, ViewChild } from '@angular/core';
import {
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
  Validator,
  NG_VALIDATORS,
  ValidationErrors
} from '@angular/forms';
import { MatOption } from '@angular/material/core';
import { MatSelect } from '@angular/material/select';
import { Obrigatorio } from 'src/app/decorators';

@Component({
  selector: 'app-select-all-options',
  templateUrl: './select-all-options.component.html',
  styleUrls: ['./select-all-options.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: SelectAllOptionsComponent,
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: SelectAllOptionsComponent,
      multi: true
    }
  ]
})
export class SelectAllOptionsComponent<T>
  implements ControlValueAccessor, Validator
{
  @ViewChild(MatSelect) selectOpcoes: MatSelect;
  private _opcoes: T[] = [];
  public get opcoes(): T[] {
    return this._opcoes;
  }
  @Obrigatorio()
  @Input()
  public set opcoes(v: T[]) {
    this._opcoes = v;
    this.verificarTodosSelecionados();
  }
  @Obrigatorio()
  @Input()
  valorOpcao: (valor: T) => any = () => {};
  @Obrigatorio()
  @Input()
  exibirOpcao: (valor: T) => string = () => '';
  todasOpcoesSelecionadas: boolean = false;
  private _opcoesSelecionadas: T[] = [];
  public get opcoesSelecionadas(): T[] {
    return this._opcoesSelecionadas;
  }
  public set opcoesSelecionadas(v: T[]) {
    this._opcoesSelecionadas = v;
    this.onChange(v);
  }
  touched = false;
  disabled = false;
  verificarTodosSelecionados() {
    if (
      this.opcoes.length > 0 &&
      this.opcoes.every((v) =>
        this.opcoesSelecionadas.includes(this.valorOpcao(v))
      )
    ) {
      this.todasOpcoesSelecionadas = true;
      return;
    }
    this.todasOpcoesSelecionadas = false;
  }
  onChange: (newValue: T[]) => void = () => {};
  onTouched: () => void = () => {};
  onValidatorChanges: () => void = () => {};
  writeValue(obj: T[]): void {
    this.opcoesSelecionadas = obj;
    this.verificarTodosSelecionados();
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  tocar() {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }
  setDisabledState(disabled: boolean) {
    this.disabled = disabled;
  }
  validate(): ValidationErrors | null {
    return null;
  }
  registerOnValidatorChange?(fn: () => void): void {
    this.onValidatorChanges = fn;
  }
  selecionarTodasOpcoes() {
    if (this.todasOpcoesSelecionadas) {
      this.selectOpcoes.options.forEach((item: MatOption) => item.select());
      return;
    }
    this.selectOpcoes.options.forEach((item: MatOption) => item.deselect());
  }
  clicouOpcao() {
    let status = true;
    this.selectOpcoes.options.forEach((item: MatOption) => {
      if (!item.selected) {
        status = false;
      }
    });
    this.todasOpcoesSelecionadas = status;
  }
}
